import * as FF_KEYS from './featureFlags';

export type FFDefaults = {
  [FF_KEYS.FF_TEST_FLAG]: boolean;
  [FF_KEYS.FF_SUPPLIER_HIDE_B2C_APPROVALS]: boolean;
  [FF_KEYS.FF_ENABLE_REPLENISHMENT_ORDERS_VIEW]: boolean;
  [FF_KEYS.FF_EXPOSE_LEGACY_ORDERS]: boolean;
};

export const ffDefaults: FFDefaults = {
  [FF_KEYS.FF_TEST_FLAG]: false,
  [FF_KEYS.FF_SUPPLIER_HIDE_B2C_APPROVALS]: true,
  [FF_KEYS.FF_ENABLE_REPLENISHMENT_ORDERS_VIEW]: false,
  [FF_KEYS.FF_EXPOSE_LEGACY_ORDERS]: false,
};
